import { AppSettings } from '../types';
import { CORRECT_CHIME, WRONG_BUZZER, SNAP_SOUND } from '../constants';

export const triggerHaptic = (settings: AppSettings, type: 'light' | 'medium' | 'heavy' | 'error' | 'success' = 'medium') => {
  if (!settings.hapticsEnabled || !window.navigator.vibrate) return;

  switch (type) {
    case 'light':
      window.navigator.vibrate(10);
      break;
    case 'medium':
      window.navigator.vibrate(20);
      break;
    case 'heavy':
      window.navigator.vibrate(50);
      break;
    case 'success':
      window.navigator.vibrate([20, 50, 20]);
      break;
    case 'error':
      window.navigator.vibrate([50, 100, 50]);
      break;
  }
};

export const playSound = (settings: AppSettings, url: string) => {
  if (!settings.sfxEnabled) return;
  const audio = new Audio(url);
  audio.play().catch(e => console.error("Audio playback failed", e));
};

export const playCorrect = (settings: AppSettings) => playSound(settings, CORRECT_CHIME);
export const playWrong = (settings: AppSettings) => playSound(settings, WRONG_BUZZER);
export const playSnap = (settings: AppSettings) => playSound(settings, SNAP_SOUND);
